import { useState, useEffect } from 'react';
import { logEvent, getAnalytics } from 'firebase/analytics';

import { useCookiesContext } from './cookies';

interface PageTrackerProps {
  pageName: string;
  userId?: string;
}

export const PageTracker = ({ pageName, userId }: PageTrackerProps) => {
  const [startTime, setStartTime] = useState<number | null>(null);
  const { cookiesAccepted } = useCookiesContext();

  useEffect(() => {
    const analytics = getAnalytics(); // Initialize Firebase Analytics
    const entryTime = Date.now();
    setStartTime(entryTime);

    return () => {
      if (startTime) {
        const exitTime = Date.now();
        const timeSpent = (exitTime - startTime) / 1000; // Convert to seconds
        if (!cookiesAccepted) return;
        logEvent(analytics, 'time_spent_on_page', {
          page_name: pageName,
          time_spent: timeSpent,
          custom_user_id: userId ?? 'unknown',
        });
      }
    };
  }, [cookiesAccepted, pageName, startTime, userId]);

  return null;
};
